<template>
    <div class="col-sm-4" v-if="can('roles.index','users.index','cashiers.index')">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">{{i18n("Employees")}}</h1>
            </div>
            <div class="card-body">
                <ul class="list-unstyled grid-list">
                    <router-link to="/roles" tag="li" v-if="can('roles.index')">
                        <a href="#" title="">{{i18n("Roles")}}</a>
                    </router-link>
                    <router-link to="/users" tag="li" v-if="can('users.index')">
                        <a href="#" title="">{{i18n("Employees")}}</a>
                    </router-link>
                    <router-link to="/api-clients" tag="li"> <!--v-if="can('api.clients')"-->
                        <a href="#" title="">{{i18n("API Clients")}}</a>
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UsersCard"
    }
</script>

<style scoped>

</style>
